import { render } from "./Inquiries.html?vue&type=template&id=1a6bd81c&ts=true"
import script from "./Inquiries.vue?vue&type=script&lang=ts"
export * from "./Inquiries.vue?vue&type=script&lang=ts"

import exportComponent from "/home/devgeorge/andrea/webpage_curaduria2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__